export default __webpack_public_path__ + "static/media/youtube.9f2651eb.svg";